import { AbstractModel } from './AbstractModel'

export class Order extends AbstractModel {
  static readonly idKey = 'customer_order_id'

  id: number|null = null
  shopOrderNr: number|null = null
  rallyId: number|null = null
  rallyRoundId: number|null = null
  teamId: number|null = null
  customerId: number|null = null
  billingAddress: string|null = null
  billingInfo: string|null = null
  description: string|null = null
  price: number|null = null
  mwst: number|null = null
  firsttext: string|null = null
  lasttext: string|null = null
}
